import { takeLatest, put, select } from 'redux-saga/effects';
import { actions as listActions } from '../slices/OrderListSlice';
import { actions as listCusOrderActions } from 'modules/customer/slices/CustomerSubsOrderListSlice';
import { actions } from '../slices/RegistrationSlice';
import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';
import ModalHandler from 'utils/modal';

const getSearchCriteria = state => state.monthlyTicketOrderList.searchCriteria;
const getCusSearchCriteria = state => state.customerSubsOrderList.searchCriteria;

function* getRegistrationOrderList({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('bus_subscription_order')}`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            }
        });
        let items = response.data?.items;
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data, items } });
        if (!(filters.status === '1' && filters.order_type === 1)) {
            const subscription_ids = response.data?.items?.map(item => item.subscription_id);
            const subscription_ids_unique = subscription_ids?.filter((value, index, self) => self.indexOf(value) === index);
            for (let i = 0; i < subscription_ids_unique.length; i++) {
                const response_card = yield NetworkHandler.get(`${config.getUrl('bus_subscriptions')}/${subscription_ids_unique[i]}`);
                items = items.map(itm => itm.subscription_id === subscription_ids_unique[i] ? { ...itm, card: response_card?.data } : itm);
            }
        }
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response.data, items } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}



function* createRegistration({ payload: { memberForm, registrationForm } }) {
    try {
        const { id, ...memberParams } = memberForm;
        let memberId = id;
        let member = {
            phone_number: memberForm.phone_number,
            full_name: memberForm.full_name,
            image_url: memberForm.image_url,
            date_of_birth: memberForm.date_of_birth,
            address: memberForm.address,
            attachments: memberForm.attachments,
        }

        const response = yield NetworkHandler.post(`${config.getUrl('bus_subscription_order')}/new`, {
            ...registrationForm,
            member_id: memberId,
            member: member,
            source : "web-admin"
        });

        yield put({ type: actions.create_registration_succeed.type, payload: { ...response.data } });
        NotificationHandler.notifySuccess('Tạo đơn đăng ký thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.create_registration_failed.type, payload: error });
    }
}

function* extendRegistration({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_subscription_order')}/extend`, {
            ...params,
            source: "web-admin"
        });
        yield put({ type: actions.extend_registration_succeed.type, payload: { ...response.data } });
        NotificationHandler.notifySuccess('Tạo đơn gia hạn thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        // yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.extend_registration_failed.type, payload: error });
    }
}

function* changeCardRegistration({ payload: { params } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_subscription_order')}/change-card`, {
            ...params
        });
        yield put({ type: actions.change_card_registration_succeed.type, payload: { ...response.data } });
        NotificationHandler.notifySuccess('Tạo đơn cấp thẻ mới thành công!');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        // yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.change_card_registration_succeed.type, payload: error });
    }
}

function* confirmCashRegistration({ payload: { id, fromCustomerSearch } }) {
    try {
        const response =
            yield NetworkHandler.post(`${config.getUrl('bus_subscription_order')}/${id}/confirm-cash-payment`);
        yield put({ type: actions.confirm_cash_registration_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Xác nhận thanh toán thành công!');
        if (fromCustomerSearch) {
            const searchCriteria = yield select(getCusSearchCriteria);
            yield put({ type: listCusOrderActions.get_list.type, payload: { ...searchCriteria } });
        } else {
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        }
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.confirm_cash_registration_failed.type, payload: error });
    }
}


function* addCardRegistration({ payload: { id, params, fromCustomerSearch } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_subscriptions')}/${id}/card`, {
            ...params
        });
        yield put({ type: actions.add_card_registration_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Gắn thẻ thành công!');
        if (fromCustomerSearch) {
            const searchCriteria = yield select(getCusSearchCriteria);
            yield put({ type: listCusOrderActions.get_list.type, payload: { ...searchCriteria } });
        } else {
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        }
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.add_card_registration_failed.type, payload: error });
    }
}

function* updateCardRegistration({ payload: { id, params, fromCustomerSearch } }) {
    try {
        const response = yield NetworkHandler.put(`${config.getUrl('bus_subscriptions')}/${id}/card`, {
            ...params
        });
        yield put({ type: actions.update_card_registration_succeed.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Đổi thẻ thành công!');
        if (fromCustomerSearch) {
            const searchCriteria = yield select(getCusSearchCriteria);
            yield put({ type: listCusOrderActions.get_list.type, payload: { ...searchCriteria } });
        } else {
            const searchCriteria = yield select(getSearchCriteria);
            yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
        }
        yield ModalHandler.closeAllModal();
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.update_card_registration_failed.type, payload: error });
    }
}
function* cancelTicket({ payload: { id } }) {
    try {
        const response = yield NetworkHandler.post(`${config.getUrl('bus_subscription_order')}/${id}/cancel`);
        yield put({ type: actions.cancel_ticket_success.type, payload: { ...response } });
        NotificationHandler.notifySuccess('Hủy đơn thành công');
        const searchCriteria = yield select(getSearchCriteria);
        yield put({ type: listActions.get_list.type, payload: { ...searchCriteria } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: actions.cancel_ticket_fail.type, payload: error });
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getRegistrationOrderList);
    yield takeLatest(actions.create_registration.type, createRegistration);
    yield takeLatest(actions.confirm_cash_registration.type, confirmCashRegistration);
    yield takeLatest(actions.extend_registration.type, extendRegistration);
    yield takeLatest(actions.change_card_registration.type, changeCardRegistration);
    yield takeLatest(actions.add_card_registration.type, addCardRegistration);
    yield takeLatest(actions.update_card_registration.type, updateCardRegistration);
    yield takeLatest(actions.cancel_ticket.type, cancelTicket);
}

export default watchRequestDetail;